module.exports = __webpack_public_path__ + "static/media/tm6_8.2a92ff70.png";